var _circle, _circle2, _path, _path2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22.5,
    fill: "#AA1070",
    stroke: "#F8EBFD",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3638,
    cy: 24.3641,
    r: 20.3636,
    fill: "#CD3F97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.0005C18.48 14.0005 14 18.4805 14 24.0005C14 29.5205 18.48 34.0005 24 34.0005C29.52 34.0005 34 29.5205 34 24.0005C34 18.4805 29.52 14.0005 24 14.0005ZM24 29.0005C23.45 29.0005 23 28.5505 23 28.0005V24.0005C23 23.4505 23.45 23.0005 24 23.0005C24.55 23.0005 25 23.4505 25 24.0005V28.0005C25 28.5505 24.55 29.0005 24 29.0005ZM25 21.0005H23V19.0005H25V21.0005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1962 7.57916C17.7048 5.0985 20.3274 5.06952 21.2001 5.36511C14.0695 7.95319 13.1767 11.8201 12.676 12.0675C10.8707 12.9593 9.81052 10.68 14.1962 7.57916Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.0468,
    cy: 4.60168,
    rx: 1,
    ry: 0.5,
    transform: "rotate(-6.00198 23.0468 4.60168)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fc1ef26cff73b6ad014f0a54f2baa21d.svg";
export { ForwardRef as ReactComponent };